import {defineAsyncComponent} from 'vue';

const EstimateArrgrateThreeYearContentPopup = defineAsyncComponent(() =>
  import('@/views/estimateArrgrateThreeYear/base/EstimateArrgrateThreeYearContentPopup.vue'),
);

export function estimateArrgrateThreeYearRegister(app) {
    app.component('EstimateArrgrateThreeYearContentPopup', EstimateArrgrateThreeYearContentPopup);
}